import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'rebass'
import { rem } from 'polished'
import media from '../../../utils/style'
import { Heading, Text, Image } from 'rebass'
import BannerVehicleOnOffer from '../../../vectors/BannerVehicleOnOffer'

const VehiclePreviewWrapper = styled(
  ({ preview, focus, maxed, win, ...rest }) => <Flex {...rest} />
)`
  position: relative;
  z-index: 1;
  text-align: center;
  align-items: flex-end;
  height: 100%;
  cursor: pointer;
  transition: opacity 1.4s ${(props) => props.theme.ease.ease_out_circ};
  opacity: ${(props) => (props.focus === props.preview ? 1 : 0.3)};
  ${media.LargeScreenUp`
  opacity: ${(props) =>
    (props.focus === props.preview ||
      props.focus === props.preview - props.win) &&
    props.maxed
      ? 1
      : 0.3};
  ${(props) => (!props.maxed ? 'opacity: 1' : '')};
  `}
  a {
    text-decoration: none;
    width: 100%;
  }
`

const VehiclePreviewBox = styled(({ outlined, reverse, buttons, ...rest }) => (
  <Box {...rest} />
))`
  position: relative;
  min-height: 235px;
  margin: 0 auto;
  &:hover::after {
    ${(props) => (!props.outlined ? 'opacity: 1;' : '')}
  }
  &::after {
    content: '';
    display: none;
    ${media.LargeScreenUp`
    display: block;
    `}
    opacity: 0;
    ${(props) =>
      props.reverse
        ? ''
        : `background-color: ${props.theme.colors.blue_light_op70};`};
    border-radius: 5px;
    position: absolute;
    z-index: -3;
    transition: opacity 1.4s ${(props) => props.theme.ease.ease_out_circ};
    top: 40px;
    bottom: 40px;
    right: 20px;
    left: 20px;
  }
`

const VehicleOutline = styled(Box)`
  position: ${(props) => (props.outlined ? 'relative' : 'initial')};
  border: 1px
    ${(props) =>
      props.outlined ? props.theme.colors.grey_light_op30 : 'transparent'}
    solid;
  padding-bottom: ${(props) => (props.outlined ? rem(40) : 0)};
`
VehicleOutline.displayName = 'VehicleOutline'

const VehiclePrice = styled(({ offer, reverse, ...rest }) => (
  <Text {...rest} />
))`
  text-transform: uppercase;
  color: ${(props) =>
    props.offer ? props.theme.colors.orange : props.theme.colors.grey_light};
  ${(props) => (props.reverse ? 'color: white !important;' : '')};
  font-weight: ${(props) => props.theme.weights[1]};
  letter-spacing: 0.11em;
  line-height: 1.3;
  & > span::before {
    content: ' | ';
    display: inline-block;
    padding: 0 10px;
  }
  & > span:first-child::before {
    content: none;
  }
`

const CardHeading = styled(({ offer, reverse, ...rest }) => (
  <Heading {...rest} />
))`
  color: ${(props) =>
    props.offer ? props.theme.colors.grey_light : props.theme.colors.blue};
  ${(props) => (props.reverse ? 'color: white !important;' : '')};
  position: relative;
  z-index: 1;
  & > span::before {
    content: ' | ';
    display: inline-block;
    padding: 0 10px;
    color: ${(props) => props.theme.colors.grey_light};
    ${(props) => (props.reverse ? 'color: white !important;' : '')};
  }
  & > span:first-child::before {
    content: none;
  }
`

const VehicleImage = styled(Image)`
  width: 100%;
  ${media.MediumScreenUp`
  min-width: ${rem(200)}
  `}
`

const CardDetail = styled(({ reverse, ...rest }) => <Box {...rest} />)`
  width: 100%;
  opacity: ${(props) => (props.focus === props.preview ? 1 : 0)};
  padding: 0 ${(props) => (props.outlined ? '8%' : 0)};
  ${media.MediumScreenUp`
  opacity: 1;
  width: auto;
  `}
  ${(props) => (props.reverse ? 'color: white !important;' : '')};
`

const OfferRoundel = styled(Box)`
  width: ${rem(85)};
  height: ${rem(85)};
  background-color: orange;
  position: absolute;
  top: 15%;
  right: 8%;
  border-radius: 50%;
  color: white;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: ${(props) => props.theme.weights[1]};
  line-height: 1;
  & > span {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
  }
`
OfferRoundel.displayName = 'BannerVehicleOnOfferRoundel'

const MotabilityRoundel = styled(Box)`
  width: ${rem(85)};
  height: ${rem(85)};
  background-color: #1e4f67;
  position: absolute;
  top: 15%;
  right: 8%;
  border-radius: 50%;
  color: white;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: ${(props) => props.theme.weights[1]};
  line-height: 1;
  & > span {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
  }
`
MotabilityRoundel.displayName = 'BannerVehicleOnOfferRoundel'

const BannerVehicleOnOfferStripe = styled(BannerVehicleOnOffer)`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 25;
`
BannerVehicleOnOfferStripe.displayName = 'BannerVehicleOnOfferStripe'

export {
  CardHeading,
  CardDetail,
  VehicleImage,
  VehiclePrice,
  VehicleOutline,
  VehiclePreviewBox,
  VehiclePreviewWrapper,
  OfferRoundel,
  MotabilityRoundel,
  BannerVehicleOnOfferStripe
}
